/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - write tests for this and refactor if needed
*/

(function () {
    /* Filter for the partners overview page */
    const filter = document.querySelector<HTMLFormElement>('[data-partners-filter]');
    if (window.location.href.indexOf('?category=') > -1) {
        if (filter) {
            const offset = 94;
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = filter.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
    }
    if (filter) {
        const filterButton = filter.querySelector<HTMLFormElement>(
            '[data-partners-filter=button]'
        );
        const categoryDropdown = filter.querySelector<HTMLFormElement>(
            '[data-partners-filter=dropdown]'
        );

        // @Todo: this is kind of a duplicate of the filterBy module. We should, perhaps, look into unifying them
        const filterButtonListener = () => {
            if (filterButton) {
                filterButton.addEventListener('click', e => {
                    e.preventDefault();
                    setSearch();
                });
            }
        };
        const setSearch = () => {
            const paramArray = [];
            const dropdownValue = categoryDropdown?.value;
            const virginUrl = window.location.origin + window.location.pathname;
            if (dropdownValue !== 'all')
                paramArray[paramArray.length] = 'category=' + dropdownValue;
            const paramString = paramArray.length > 0 ? `?${paramArray.join('&')}` : '';

            window.location.assign(virginUrl + paramString);
        };

        return {
            init: filterButtonListener,
        };
    }
})()?.init();
